import { render, staticRenderFns } from "./DependentsFormPartialComponent.vue?vue&type=template&id=a35b1dde&"
import script from "./DependentsFormPartialComponent.vue?vue&type=script&lang=ts&"
export * from "./DependentsFormPartialComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a35b1dde')) {
      api.createRecord('a35b1dde', component.options)
    } else {
      api.reload('a35b1dde', component.options)
    }
    module.hot.accept("./DependentsFormPartialComponent.vue?vue&type=template&id=a35b1dde&", function () {
      api.rerender('a35b1dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Partials/DependentsFormPartialComponent.vue"
export default component.exports